import { createIdSlice } from '../utils/action/createElementSlice';
export const OverviewState = createIdSlice({
    elementName: 'overview',
    initialState: {},
    reducers: {
        /**
         * Sets OverviewState. Setting undefined deletes any existing state.
         */
        set(_state, action) {
            return action.payload.data;
        },
        /**
         * Indicates the user has toggled overviews on or off.
         */
        notifyToggleOverview(state) {
            return state;
        },
        /**
         * Sets isOverviewOn to the given value
         */
        setIsOverviewOn(state, action) {
            return Object.assign(Object.assign({}, state), { isOverviewOn: action.payload.data });
        },
        /**
         * @deprecated use the more general set action
         */
        init(_state, action) {
            return action.payload.data;
        },
        /**
         * @deprecated replaced by notifyToggleOverview
         */
        toggleOverview(state) {
            return state;
        },
    },
});
